import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import withAuth from './components/auth/withAuth'
// Routes
import Main from './routes/Main'
import UnauthorizedPage from './routes/UnauthorizedPage'

class App extends React.Component {
    render() {
        const MainContent = withAuth(Main)

        return (
            <Router>
                <Switch>
                    <Route
                        exact
                        path={'/unauthorized'}
                        component={UnauthorizedPage}
                    />
                    <MainContent />
                </Switch>
            </Router>
        )
    }
}

export default App
